import React, { useRef } from "react";
import "./Join.css";
import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef();
  const sendEmail = (e) => {
    //e.preventDefault();

    emailjs
      .sendForm(
        "service_oswmkt8",
        "template_ji5r82m",
        form.current,
        "ULwwBgryS--DtcYuk"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className="join" id="join-us">
      <div className="left-j" style={{ textTransform: "uppercase" }}>
        <hr />
        <div>
          <span className="outline-text">Ready to</span>
          <span> level up</span>
        </div>
        <div>
          <span>your body</span>
          <span className="outline-text"> with us?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container" onSubmit={sendEmail} >
          <input
            type="email"
            name="user_email"
            placeholder="Enter Your Email Address"
          />
          <button className="btn btn-j" >Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
